import { whiteListAccountsForSpecialSalary, whiteListCifForSpecialSalary } from 'consts';
export const hasViewPermission = (status)=>{
    return !![
        'READY_FOR_PAYMENT',
        'PROCESSING',
        'ERROR',
        'WAITING_AUTHORIZE',
        'AUTHORIZED',
        'REJECTED',
        'COMPLETED',
        'PENDING_APPROVAL'
    ].includes(status);
};
export const getRecordIcon = (status)=>{
    switch(status){
        case 'VALIDATING':
            return 'validating';
        case 'VALIDATING_ERROR':
            return 'error';
        case 'WARNING':
            return 'warning';
        case 'READY':
            return 'ready';
        default:
            return 'draft';
    }
};
export const hasAnyPermission = (permissionsData, operationType, type)=>{
    return operationType.some((item)=>{
        var _permissionsData_;
        return permissionsData === null || permissionsData === void 0 ? void 0 : (_permissionsData_ = permissionsData[`${item}`]) === null || _permissionsData_ === void 0 ? void 0 : _permissionsData_.some((account)=>{
            var _account_permissions;
            return account === null || account === void 0 ? void 0 : (_account_permissions = account.permissions) === null || _account_permissions === void 0 ? void 0 : _account_permissions[`${type}`];
        });
    });
};
export const hasPermissionAccount = (accounts, cif)=>{
    return (accounts === null || accounts === void 0 ? void 0 : accounts.some((account)=>whiteListAccountsForSpecialSalary.includes(account.accountNo))) && cif === whiteListCifForSpecialSalary;
};
export const hasPermission = (permissionsData, operationType, type)=>{
    var _permissionsData_permissions_, _permissionsData_permissions;
    return permissionsData === null || permissionsData === void 0 ? void 0 : (_permissionsData_permissions = permissionsData.permissions) === null || _permissionsData_permissions === void 0 ? void 0 : (_permissionsData_permissions_ = _permissionsData_permissions[`${operationType}`]) === null || _permissionsData_permissions_ === void 0 ? void 0 : _permissionsData_permissions_.some((account)=>{
        var _account_permissions;
        return account === null || account === void 0 ? void 0 : (_account_permissions = account.permissions) === null || _account_permissions === void 0 ? void 0 : _account_permissions[`${type}`];
    });
};
